const organizationStatus = {
    STATUS_ALL : -1,

    STATUS_INACTIVE : 0,

    STATUS_ACTIVE : 1,

    STATUS_HIDDEN : 0,

    STATUS_DRAFT : 2

};

angular.module('gw-um-j2js')
    .constant('organizationStatus', organizationStatus);